module.exports = __webpack_public_path__ + "img/profile.e81becb0.png";